import React from 'react';
import useSubscriptions from '@afosto/utils-react/subscription/useSubscriptions';
import { useShipmentContext } from '../../../components/ShipmentProvider';
import Grid from '@material-ui/core/Grid';
import OrdersSection from '@afosto/app-components-react/OrdersSection';
import ShipmentAddressSection from './ShipmentAddressSection';
import ShipmentContactSection from './ShipmentContactSection';
import ShipmentHandlingListSection from './ShipmentHandlingListSection';
import ShipmentInfoSection from './ShipmentInfoSection';
import ShippingMethodSection from './ShippingMethodSection';
import ShipmentStatusSection from './ShipmentStatusSection';

const ShipmentDetails = () => {
  const subscriptions = useSubscriptions();
  const hasOrdersSubscription = subscriptions.some(({ code }) => code === 'odr');
  const { orderIds } = useShipmentContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <ShipmentInfoSection />
          </Grid>
          <Grid item xs={12} md={4}>
            <ShipmentStatusSection />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ShipmentContactSection />
          </Grid>
          <Grid item xs={12}>
            <ShippingMethodSection />
          </Grid>
          <Grid item xs={12}>
            <ShipmentAddressSection />
          </Grid>
          <Grid item xs={12}>
            <ShipmentHandlingListSection />
          </Grid>
          {hasOrdersSubscription && (
            <Grid item xs={12}>
              <OrdersSection orderIds={orderIds} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ShipmentDetails;
